import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SkillDocumentResponse, SkillPracticeTaskStatus } from '../../../models/skill-learning.model';

type SkillDocumentInput = SkillDocumentResponse | null;
type SkillPracticeTaskStatusInput = SkillPracticeTaskStatus | null;

const PRACTICE_STATUS_LABELS: { [key: string]: string } = {
  'CREATED': 'SKILL_LEARNING_PRACTICE_STATUS_CREATED',
  'IN_WORK': 'SKILL_LEARNING_PRACTICE_STATUS_IN_WORK',
  'COMPLETED': 'SKILL_LEARNING_PRACTICE_STATUS_COMPLETED',
  'CANCELLED': 'SKILL_LEARNING_PRACTICE_STATUS_CANCELLED',
};

@Component({
  selector: 'app-practice-level',
  templateUrl: './practice-level.component.html',
  styleUrls: ['./practice-level.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PracticeLevelComponent {

  @Input() level: number;
  @Input() description: string = '';
  @Input() documentFileId: string | null = null;
  @Input() document: SkillDocumentInput = null;
  @Input() taskStatus: SkillPracticeTaskStatusInput = null;
  @Input() assignedCuratorName: string | null = null;
  @Input() assignedCuratorPhone: string | null = null;
  @Input() isDisabled: boolean = false;

  @Output() startClicked = new EventEmitter<void>();

  get isCompleted(): boolean {
    return this.taskStatus === 'COMPLETED';
  }

  get canStart(): boolean {
    return !this.taskStatus && !this.isDisabled;
  }

  get hasDocument(): boolean {
    return !!this.document || !!this.documentFileId;
  }

  get hasCurator(): boolean {
    return this.canShowCuratorStatus && this.hasCuratorContacts;
  }

  get canShowCuratorStatus(): boolean {
    return this.taskStatus === 'CREATED' || this.taskStatus === 'IN_WORK';
  }

  get hasCuratorContacts(): boolean {
    return !!this.assignedCuratorName || !!this.assignedCuratorPhone;
  }

  get statusLabel(): string {
    if (!this.taskStatus) {
      return '';
    }
    return PRACTICE_STATUS_LABELS[this.taskStatus] || '';
  }

  onStartClick(): void {
    if (this.canStart) {
      this.startClicked.emit();
    }
  }

  onDownloadClick(): void {}
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/user/practice-level/practice-level.component.ts